import { lazy } from "react";
import Loadable from "app/components/Loadable";

const SupportPage = Loadable(lazy(() => import("./SupportPage")));

const supportRoutes = [{ path: "/support", element: <SupportPage /> }];

export default supportRoutes;
